/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily>): BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily(), model);
        BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily>): BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily.newInstance(<BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
